import React, { useEffect, useRef, useState } from "react";

function CounterSection() {
  const countersRef = useRef([]);
  const sectionRef = useRef(null);
  const [counters, setCounters] = useState([]);

  /* ===== COUNTER + SCROLL ANIMATION ===== */
  useEffect(() => {
    const animateCounter = (el, target) => {
      let count = 0;
      const duration = 2000;
      const stepTime = Math.max(20, Math.floor(duration / target));

      const timer = setInterval(() => {
        count += 1;
        el.innerText = count + "+";
        if (count >= target) {
          clearInterval(timer);
          el.innerText = target + "+";
        }
      }, stepTime);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && sectionRef.current) {
            countersRef.current.forEach((counterEl, index) => {
              if (
                counterEl &&
                !counterEl.classList.contains("counted")
              ) {
                const target = counters[index]?.value;
                if (typeof target === "number") {
                  animateCounter(counterEl, target);
                  counterEl.classList.add("counted");
                }
              }
            });

            sectionRef.current.classList.add("in-view");
          }
        });
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [counters]);

  /* ===== JSON + XML ===== */
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/counters.json")
      .then(res => res.json())
      .then(data => {
        console.log("COUNTERS JSON:", data);
        setCounters(data?.counters || []);
      })
      .catch(err => console.error("COUNTERS JSON ERROR:", err));

    // ✅ XML → exam / proof
    fetch("/api/counters.xml")
      .then(res => res.text())
      .then(() => console.log("Counters XML loaded"));
  }, []);

  return (
    <>
      {/* ✅ SECTION ALWAYS RENDER */}
      <section className="counter-section" ref={sectionRef}>
        <div className="counter-container">

          {counters.map((item, index) => (
            <div
              key={index}
              className={`counter-box ${item.animation}`}
            >
              <div className={`icon ${item.iconClass}`}>
                <img src={item.icon} alt={item.label} />
              </div>

              <h3 ref={(el) => (countersRef.current[index] = el)}>
                0+
              </h3>

              <p>{item.label}</p>
            </div>
          ))}

        </div>
      </section>

      <style>{`
/* ================= COUNTER SECTION ================= */

.counter-section {
  padding: 80px 20px;        /* 🔥 MORE SPACE */
  margin-top: 80px;         /* 🔥 FIX overlap from Activities */
  background: #fff;
}

.counter-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  text-align: center;
}

/* CARD */
.counter-box {
  padding: 30px 20px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  opacity: 0;
  transition: all 0.9s ease;
}

.counter-section.in-view .counter-box {
  opacity: 1;
  transform: translateY(0);
}

.reveal-left {
  transform: translateX(-60px);
}

.reveal-right {
  transform: translateX(60px);
}

/* TEXT */
.counter-box h3 {
  font-size: 36px;
  font-weight: 700;
  margin: 15px 0 10px;
}

.counter-box p {
  font-size: 15px;
  color: #241E20;
}

/* ICON */
.icon {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
}

.icon img {
  width: 35px;
}

/* COLORS */
.red { background: rgba(255, 0, 0, 0.1); }
.blue1 { background: rgba(0, 123, 255, 0.1); }
.green1 { background: rgba(0, 200, 83, 0.15); }
.orange { background: rgba(255, 193, 7, 0.2); }

/* RESPONSIVE */
@media (max-width: 992px) {
  .counter-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .counter-container {
    grid-template-columns: 1fr;
  }
}
      `}</style>
    </>
  );
}

export default CounterSection;
